// src/components/LearnersTable.js
import React from "react";
import { Table, Button, Card } from "antd";
import useNewEmployees from  "PlatForms/OrgLMS/Hooks/ManagerHooks/useNewEmployees";
import { useNavigate } from "react-router-dom";

// Replace with actual token logic (maybe from context or localStorage)
const token = localStorage.getItem("token");

const EmployeeSearch = () => {
  const { learners, loading, loadingRowId, pickLearner } = useNewEmployees(token);
  const navigate = useNavigate();

  const columns = [
    {
      title: "Learner ID",
      dataIndex: "learnerId",
      key: "learnerId",
    },
    {
      title: "Full Name",
      render: (text, record) => `${record.firstName} ${record.lastName}`,
      key: "fullName",
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
    },
    {
      title: "Business Group Name",
      dataIndex: "businessGroupName",
      render: (text) => (text ? text : "N/A"),
    },
    {
      title: "Created On",
      dataIndex: "createdOn",
      key: "createdOn",
      render: (text) => new Date(text).toLocaleDateString(),
    },
    {
      title: "Action",
      key: "action",
      render: (text, record) => (
        <Button
          type="primary"
          loading={loadingRowId === record.learnerId}
          onClick={() => pickLearner(record.learnerId)}
        >
          {loadingRowId === record.learnerId ? "Please wait..." : "Pick As Employee"}
        </Button>
      ),
    },
  ];

  return (
    <Card
      title="New Employees"
      loading={loading}
      className="card-professional"
      extra={
        <Button type="default" onClick={() => navigate("/new-employees")}>
          Back
        </Button>
      }
    >
      <Table
        columns={columns}
        dataSource={learners}
        rowKey="learnerId"
        pagination={{ pageSize: 5 }}
      />
    </Card>
  );
};

export default EmployeeSearch;
